import React from 'react';
import { TitleWrapper } from './Title.styled';

function Title() {
  return (
    <TitleWrapper>
      <h1>Box Office</h1>
      <p>Are you looking for a show or an actor?</p>
    </TitleWrapper>
  )
}

export default Title
